// src/utils/getCityOptions.ts

import * as api from "src/api/app";
import { devLogging } from "src/utils/logger";

interface UserRoles {
  username: string;
  cities: string[];
  pods: string[];
  metrics: number[];
  metricNames: string[];
  podNames: string[];
  admin: boolean;
  restaurantIds: string[];
  misRole: string;
}

interface CityOption {
  value: string;
  label: string;
}

export const getCityOptions = (userRoles: UserRoles): CityOption[] => {
  const cities = userRoles?.cities || [];
  return cities.map((city) => ({
    value: city,
    label: `${city}`,
  }));
};

export const getPodIdAndPodNameMapping = (userRoles: UserRoles): { [key: string]: string } => {
  const pods = userRoles?.pods || [];
  const podNames = userRoles?.podNames || [];
  return pods.reduce((acc, pod, index) => {
    acc[pod] = podNames[index];
    return acc;
  }, {});
};

export const getPodOptions = async (userRoles: UserRoles, selectedCity: string): Promise<any> => {
  let podToPodNameMap = getPodIdAndPodNameMapping(userRoles);
  try {
    const { response, error } = await api.getUserCityPodMapping();
    if (error) {
      console.log("Error fetching user roles", error);
      return [];
    }
    devLogging("response 1234", response);

    const pods = response[selectedCity] || [];
    console.log("pod and index", pods);
    const podNames = userRoles?.podNames || [];
    return pods.map((pod, index) => {
      devLogging("pod and index", pod, podNames[index], index);
      return {
        value: pod,
        label: podToPodNameMap[pod],
      };
    });
  } catch (error) {
    console.log("Error fetching user roles", error);
    return [];
  }
};
